export function formatDateToRc(format: string): string {
    if (!format) return '';

    // Replace DD with dd for day format
    let result = format.replace(/DD/g, 'dd');
    
    // Replace YYYY with yyyy for year format
    result = result.replace(/YYYY/g, 'yyyy');
    
    return result;
}
